import { useEffect, useState } from 'react';
import { Button, InputGroup } from 'react-bootstrap';
import { PencilFill, PlusCircleFill } from 'react-bootstrap-icons';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { getAccountOfficers } from '../../../../api/customerAccountOfficer';
import AccountOfficerFormModal from '../AccountSpecialistFormModal.js';
import './styles.css';

const AccountOfficerDropdown = ({ selected, onChange, fallbackOption }) => {
  const [data, setData] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [editData, setEditData] = useState(null);
  const [toggleAccountOfficerModal, setToggleAccountOfficerModal] =
    useState(false);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (selectedId === '' && selected) {
      setSelectedId(typeof selected === 'object' ? selected.ao_id : selected);
    }
  }, [selected]);

  const loadData = async () => {
    try {
      const res = await getAccountOfficers();

      const { code, result } = res.data.response;

      if (code !== '00000') {
        setData([]);
        setRawData([]);
        toast.error(Array.isArray(result) ? result.join('<br />') : result);
        return;
      }

      setRawData(result);
      setData(
        result.map((row) => ({
          value: row.ao_id,
          label: row.ao_name,
        })),
      );
    } catch (error) {
      toast.error(error.message);
    }
  };

  // Include the saved officer as an option even if it's no longer active
  // (deactivated officers aren't returned by /customer/ao/all), otherwise
  // the Select can't match the saved value and shows empty.
  const options =
    fallbackOption &&
    fallbackOption.value &&
    !data.some((row) => String(row.value) === String(fallbackOption.value))
      ? [fallbackOption, ...data]
      : data;

  const handleChange = (e) => {
    setSelectedId(e.value);
    onChange({
      target: { name: 'AO', value: e.value },
    });
  };

  const handleAccountOfficerFormToggle = () =>
    setToggleAccountOfficerModal(!toggleAccountOfficerModal);

  const handleAddAccountOfficer = () => {
    setEditData(null);
    setToggleAccountOfficerModal(true);
  };

  const handleEditAccountOfficer = () => {
    const selectedOfficer = rawData.find(
      (row) => String(row.ao_id) === String(selectedId),
    );

    if (!selectedOfficer) return;

    setEditData(selectedOfficer);
    setToggleAccountOfficerModal(true);
  };

  const handleAccountOfficerFormSubmitted = async (data) => {
    if (data.success) {
      loadData();
      handleAccountOfficerFormToggle();

      setSelectedId(data.result?.ao_id);
      onChange({
        target: { name: 'AO', value: data.result?.ao_id },
      });
    }
  };

  return (
    <div>
      <div className="dropdown-account-officer-container">
        <InputGroup className="mb-3">
          <Button
            variant="primary"
            id="button-dropdown-account-officer"
            className="dropdown-account-officer-add-button"
            onClick={handleAddAccountOfficer}
          >
            <PlusCircleFill className="dropdown-account-officer-add-icon" />
          </Button>
          <Select
            options={options}
            value={
              selectedId
                ? options.find(
                    (row) => String(row.value) === String(selectedId),
                  ) || ''
                : ''
            }
            className="form-control padding-0 dropdown-account-officer-select"
            classNamePrefix="dropdown-account-officer-select_"
            onChange={handleChange}
          />
          {selectedId && (
            <Button
              variant="primary"
              id="button-dropdown-account-officer-edit"
              className="dropdown-account-officer-edit-button"
              onClick={handleEditAccountOfficer}
            >
              <PencilFill className="dropdown-account-officer-edit-icon" />
            </Button>
          )}
        </InputGroup>
      </div>
      <AccountOfficerFormModal
        toggle={toggleAccountOfficerModal}
        onClose={handleAccountOfficerFormToggle}
        onSubmitted={handleAccountOfficerFormSubmitted}
        editData={editData}
      />
    </div>
  );
};

export default AccountOfficerDropdown;
